
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'kn-hint',
    props: { title: String, hint: String }
})
